﻿import * as Message from "./validationMessage";

export class ValidateResult {
    constructor() {
        this.validationMessage = null;
        this.isValid = true;
    }

    validationMessage: Message.ValidationMessage | Message.ValidationMessage[];

    get isValid() {
        return !this.validationMessage ||
            (Array.isArray(this.validationMessage) ? (this.validationMessage as Message.ValidationMessage[]).length <= 0 : false);
    }
     set isValid(val) {}
}